import styled from 'styled-components'

const InvestmentProjectsStyle = styled.div.attrs({ className: 'investment-projects' })`
	.inv-proj {
		display: flex;
		flex-direction: column;

		.page-title {
			max-width: var(--sp75x);
		}

		.main-block {
			display: flex;

			> .relativeWrapp {
				width: 100%;
				margin: var(--sp10x) auto 0;
			}
			&.disable {
				.invest-ranges,
				.block,
				.single-cat,
				.clear-filters,
				.single-filter > .MuiCollapse-container {
					opacity: 0.5 !important;
					pointer-events: none;
				}
			}
		}
	}

	.no-result {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: var(--sp10x) auto 0;

		.imageCont {
			width: var(--sp18x);
			padding-top: var(--sp18x);
		}

		.title {
			margin: var(--sp5x) 0 var(--sp3x);
		}
	}

	//* Filters and search
	.list-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) {
		.list-head {
			flex-direction: column;
			align-items: flex-end;
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSize}) {
		.main-block {
			margin-top: var(--sp9x);
		}

		.list-head {
			.search-field-cont {
				position: absolute;
				top: calc(-1 * var(--sp9x));
			}
		}
	}
	//* End Filters and search

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		.inv-proj {
			.page-title {
				max-width: var(--sp73x);
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		.inv-proj {
			.page-title {
				max-width: var(--sp64x);
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		.inv-proj {
			.page-title {
				max-width: var(--sp55x);
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		.inv-proj {
			.page-title {
				max-width: var(--sp55x);
			}

			.main-block {
				flex-direction: column;
				position: relative;
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.inv-proj {
			.page-title {
				max-width: unset;
			}

			.main-block {
				flex-direction: column;
				position: relative;
				> .relativeWrapp {
					margin: var(--sp5x) auto 0;
				}
			}
		}
	}
`
export default InvestmentProjectsStyle
